import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
const LARGOMAXIMO = 500;
@Component({
    selector: "app-dialog-corregir",
    templateUrl: "./dialog-corregir.component.html",
    styleUrls: ["./dialog-corregir.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class DialogCorregirComponent implements OnInit {
    formCorreccion: FormGroup;
    largoMaximo: number;
    constructor(
        public dialogRef: MatDialogRef<DialogCorregirComponent>,
        private _fb: FormBuilder
    ) {
        this.largoMaximo = LARGOMAXIMO;
    }

    ngOnInit(): void {
        this.initForm();
    }

    initForm() {
        this.formCorreccion = this._fb.group({
            observaciones: [
                "",
                {
                    validators: [
                        Validators.required,
                        Validators.minLength(1),
                        Validators.maxLength(LARGOMAXIMO),
                    ],
                },
            ],
        });
    }

    get observaciones() {
        return this.formCorreccion.get("observaciones");
    }
}
